import { render } from "./AdminTextArea.vue?vue&type=template&id=0b6d709e&scoped=true&ts=true"
import script from "./AdminTextArea.vue?vue&type=script&lang=ts"
export * from "./AdminTextArea.vue?vue&type=script&lang=ts"

import "./AdminTextArea.vue?vue&type=style&index=0&id=0b6d709e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6d709e"]])

export default __exports__